import {
  useContext,
  useEffect,
  useState,
  ReactNode,
  createContext,
  Dispatch,
  SetStateAction,
} from "react";
import AuthContext from "./AuthContext";

type SearchContextType = {
  searchFrom: Date;
  setSearchFrom: Dispatch<SetStateAction<Date>>;
  searchTo: Date;
  setSearchTo: Dispatch<SetStateAction<Date>>;
  resetSearchRange: () => { from: Date; to: Date };
};

const createDefaultRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  return {
    from: new Date(year, month, 1),
    to: new Date(year, month + 1, 0),
  };
};

const SearchContext = createContext({
  searchFrom: new Date(),
  searchTo: new Date(),
  resetSearchRange: () => {},
} as SearchContextType);

export default SearchContext;

export const SearchContextProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const { selectedPark } = useContext(AuthContext);

  // 1日～月末がデフォルト
  const defaultRange = createDefaultRange();
  const [searchFrom, setSearchFrom] = useState(defaultRange.from);
  const [searchTo, setSearchTo] = useState(defaultRange.to);

  const resetSearchRange = () => {
    const { from, to } = createDefaultRange();
    setSearchFrom(from);
    setSearchTo(to);
    return { from, to };
  };

  useEffect(() => {
    resetSearchRange();
  }, [selectedPark?.parkId]);

  const contextValue = {
    searchFrom,
    setSearchFrom,
    searchTo,
    setSearchTo,
    resetSearchRange,
  };

  return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
};
